<div class="flex flex-1 flex-col">
  <div class="flex flex-row p-4 pr-6 py-3 border-b border-gray-1">
    <div class="h-8 flex flex-1 flex-wrap content-center uppercase text-xs font-bold">
      {{ title() }}
    </div>
    <button
      modus-icon-button
      id="recycle-bin-options-panel-multi-close"
      class="text-gray-8"
      [modus-tooltip]="translations.close.tooltip.text"
      [disabled]="disabled()"
      (click)="closeClicked.emit()"
    >
      <md-icon>close</md-icon>
    </button>
  </div>

  <div class="flex-1 overflow-y-scroll p-4" cdkScrollable>
    <div class="flex flex-col max-w-full">
      <sd-label-value
        label="{{ translations.size.text }}"
        value="{{ totalSize() | fileSize: 1 | dashedIfEmpty }}"
        data-cy="properties-capture-date-label"
      ></sd-label-value>
    </div>
  </div>
</div>
